import { render } from "./GroupsList.vue?vue&type=template&id=a75c9138&ts=true"
import script from "./GroupsList.vue?vue&type=script&lang=ts"
export * from "./GroupsList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__